import { httpClient } from '../../../../net/httpClient';
import UrlConfig from '../../../../net/UrlConfig';


import {
    // query
    ON_QUERY_INPUT_CHANGE,
    START_LOAD_USER_ACCESS_INFO,
    LOAD_USER_ACCESS_INFO_SUCCESS,
    LOAD_USER_ACCESS_INFO_FAILURE,
    INIT_LOAD_USER_ACCESS_INFO_ACTION_STATUS,
    // select
    SELECT_USER_ACCESS_INFO,
    // add or edit
    OPEN_ADD_OR_EDIT_USER_ACCESS_MODAL,
    ADD_OR_EDIT_USER_ACCESS_CHANGE_INPUT,
    START_ADD_OR_EDIT_USER_ACCESS,
    ADD_OR_EDIT_USER_ACCESS_SUCCESS,
    ADD_OR_EDIT_USER_ACCESS_FAILURE,
    INIT_ADD_OR_EDIT_USER_ACCESS_ACTION_STATUS,
    RESET_ADD_OR_EDIT_USER_ACCESS_MODAL,
    // refresh fx and amtUSD
    START_REFRESH_FX,
    REFRESH_FX_SUCCESS,
    REFRESH_FX_FAILURE,
    INIT_REFRESH_FX_ACTION_STATUS,
    REFRESH_AMT_USD,
    // del
    OPEN_DEL_USER_ACCESS_MODAL,
    DEL_USER_ACCESS_CHANGE_INPUT,
    START_DEL_USER_ACCESS,
    DEL_USER_ACCESS_SUCCESS,
    DEL_USER_ACCESS_FAILURE,
    INIT_DEL_USER_ACCESS_ACTION_STATUS,
    RESET_DEL_USER_ACCESS_MODAL,

    // COP
    OPEN_COP_USER_ACCESS_MODAL,
    COP_USER_ACCESS_CHANGE_INPUT,
    START_COP_USER_ACCESS,
    COP_USER_ACCESS_SUCCESS,
    COP_USER_ACCESS_FAILURE,
    INIT_COP_USER_ACCESS_ACTION_STATUS,
    RESET_COP_USER_ACCESS_MODAL,



    LOAD_RESTRICTED_SECURITIES_RULE_SUCCESS,
    LOAD_RESTRICTED_SECURITIES_RULE_FAILURE,



    OPEN_FINISH_TASK_MODAL,

    OPEN_OPERATION_RECORD_DIALOG,
    START_QUERY_OPERATION_RECORD,
    QUERY_OPERATION_RECORD_SUCESS,
    QUERY_OPERATION_RECORD_FAILURE,
    INIT_QUERY_OPERATION_RECORD_STATUS,
    RESET_OPERATION_RECORD_DIALOG,
    // detail
    SHOW_DETAIL_RCD,
    RESET_DETAIL_RCD,

    LOAD_INSTITUTE_USER_ACCOUNT_SUCCESS,
    LOAD_INSTITUTE_USER_ACCOUNT_FAILURE

} from './MeetingAndTrainingReviewConstants';


// query
export function onQueryInputChange({name, value}) {
    return {
        type: ON_QUERY_INPUT_CHANGE,
        payload: {
          name,
          value,
        }
    };
}
function startLoadMeetingAndTrainingReviewInfo() {
    return {
      type: START_LOAD_USER_ACCESS_INFO,
    };
}
export function loadMeetingAndTrainingReviewInfo(params) {
    return function(dispatch) {
        dispatch(startLoadMeetingAndTrainingReviewInfo());
        httpClient
        //   .get(UrlConfig.LOAD_MEETING_AND_TRAINING_INFO_SUB, params)
          .get(UrlConfig.LOAD_MEETING_AND_TRAINING_INFOTO_SUB, params)
          .then(resp => dispatch(loadMeetingAndTrainingReviewInfoSuccess(resp)))
          .catch(err => dispatch(loadMeetingAndTrainingReviewInfoFailure(err)));
    };
}
function loadMeetingAndTrainingReviewInfoSuccess(resp) {
    return {
      type: LOAD_USER_ACCESS_INFO_SUCCESS,
      payload: resp,
    };
}
function loadMeetingAndTrainingReviewInfoFailure(err) {
    return {
        type: LOAD_USER_ACCESS_INFO_FAILURE,
        payload: err,
    };
}
export function initLoadMeetingAndTrainingReviewInfoActionStatus() {
    return {
      type: INIT_LOAD_USER_ACCESS_INFO_ACTION_STATUS,
    };
}

// select
export function selectMeetingAndTrainingReviewInfo(array) {
    return {
        type: SELECT_USER_ACCESS_INFO,
        payload: array,
    };
}


// add or edit
export function openAddOrEditMeetingAndTrainingReviewModal(mode, data) {
    return {
        type: OPEN_ADD_OR_EDIT_USER_ACCESS_MODAL,
        payload: {
            mode,
            data,
        },
    };
}
export function addOrEditMeetingAndTrainingReviewChangeInput({name, value}) {
    return {
        type: ADD_OR_EDIT_USER_ACCESS_CHANGE_INPUT,
        payload: {
          name,
          value,
        }
    };
}
function startAddOrEditMeetingAndTrainingReview() {
    return {
        type: START_ADD_OR_EDIT_USER_ACCESS,
    };
}
export function addOrEditMeetingAndTrainingReview(params) {
      return function(dispatch) {
        dispatch(startAddOrEditMeetingAndTrainingReview());
        httpClient
          .post(UrlConfig.ADD_OR_EDIT_USER_ACCESS, params)
          .then(resp => dispatch(addOrEditMeetingAndTrainingReviewSuccess(resp)))
          .catch(err => dispatch(addOrEditMeetingAndTrainingReviewFailure(err)));
      };
}
function addOrEditMeetingAndTrainingReviewSuccess(resp) {
    return {
        type: ADD_OR_EDIT_USER_ACCESS_SUCCESS,
        payload: resp,
    };
}
function addOrEditMeetingAndTrainingReviewFailure(err) {
    return {
        type: ADD_OR_EDIT_USER_ACCESS_FAILURE,
        payload: err,
    };
}
export function initAddOrEditMeetingAndTrainingReviewActionStatus() {
    return {
        type: INIT_ADD_OR_EDIT_USER_ACCESS_ACTION_STATUS,
    };
}
export function resetAddOrEditMeetingAndTrainingReviewModal() {
    return {
        type: RESET_ADD_OR_EDIT_USER_ACCESS_MODAL,
    };
}


// refresh fx and amtUSD
function startRefreshFx() {
    return {
        type: START_REFRESH_FX,
    };
}
export function refreshFx({currInvDate, currCcy}) {
    if(!currInvDate || !currCcy) {
        return function(dispatch) {
            dispatch(refreshFxSuccess(null));
        }
    } else {
        const params = {
            fromCurrencyCode: 'USD',
            toCurrencyCode: currCcy,
            specifiedDateStr: currInvDate,
        };
        return function(dispatch) {
            dispatch(startRefreshFx());
            httpClient
            .get(UrlConfig.GET_FX_BY_NEAREST_DATE, params)
            .then(resp => dispatch(refreshFxSuccess(resp)))
            .catch(err => dispatch(refreshFxFailure(err)));
        };
    }
}
function refreshFxSuccess(resp) {
    return {
        type: REFRESH_FX_SUCCESS,
        payload: resp,
    };
}
function refreshFxFailure(err) {
    return {
        type: REFRESH_FX_FAILURE,
        payload: err,
    };   
}
export function initRefreshFxActionStatus() {
    return {
        type: INIT_REFRESH_FX_ACTION_STATUS,
    };
}
export function refreshAmtUSD({currAmount, currFx}) {
    let amtUSD = '';
    if(!!currAmount && !!currFx) {
        amtUSD = currAmount / currFx;
        amtUSD = Math.round(amtUSD * 100) / 100;
    }
    if(isNaN(amtUSD)) {
        amtUSD = '';
    }
    return {
        type: REFRESH_AMT_USD,
        payload: amtUSD,
    }
}


// del
export function openDelMeetingAndTrainingReviewModal(info,mode) {
    return {
        type: OPEN_DEL_USER_ACCESS_MODAL,
        payload: 
        {
            info,
            mode,
        },
    };  
}
export function delMeetingAndTrainingReviewChangeInput({name, value}) {
    return {
        type: DEL_USER_ACCESS_CHANGE_INPUT,
        payload: {
          name,
          value,
        }
    };
}
function startDelMeetingAndTrainingReview() {
    return {
        type: START_DEL_USER_ACCESS,
    };
}
export function delMeetingAndTrainingReview(params) {
      return function(dispatch) {
        dispatch(startDelMeetingAndTrainingReview());
        httpClient
          .get(UrlConfig.UPDATED_NOTE, params)
          .then(resp => dispatch(delMeetingAndTrainingReviewSuccess(resp)))
          .catch(err => dispatch(delMeetingAndTrainingReviewFailure(err)));
      };
}
function delMeetingAndTrainingReviewSuccess(resp) {
    return {
        type: DEL_USER_ACCESS_SUCCESS,
        payload: resp,
    };
}
function delMeetingAndTrainingReviewFailure(err) {
    return {
        type: DEL_USER_ACCESS_FAILURE,
        payload: err,
    };
}
export function initDelMeetingAndTrainingReviewActionStatus() {
    return {
        type: INIT_DEL_USER_ACCESS_ACTION_STATUS,
    };
}
export function resetDelMeetingAndTrainingReviewModal() {
    return {
        type: RESET_DEL_USER_ACCESS_MODAL,
    };
}

//cop
export function openCopMeetingAndTrainingReviewModal(info) {
    return {
        type: OPEN_COP_USER_ACCESS_MODAL,
        payload: info,
    };  
}
export function copMeetingAndTrainingReviewChangeInput({name, value}) {
    return {
        type: COP_USER_ACCESS_CHANGE_INPUT,
        payload: {
          name,
          value,
        }
    };
}
function startCopMeetingAndTrainingReview() {
    return {
        type: START_COP_USER_ACCESS,
    };
}
export function copMeetingAndTrainingReview(params) {
      return function(dispatch) {
        dispatch(startCopMeetingAndTrainingReview());
        httpClient
          .get(UrlConfig.COP_ALL_USER_ACCESS, params)
          .then(resp => dispatch(copMeetingAndTrainingReviewSuccess(resp)))
          .catch(err => dispatch(copMeetingAndTrainingReviewFailure(err)));
      };
}
function copMeetingAndTrainingReviewSuccess(resp) {
    return {
        type: COP_USER_ACCESS_SUCCESS,
        payload: resp,
    };
}
function copMeetingAndTrainingReviewFailure(err) {
    return {
        type: COP_USER_ACCESS_FAILURE,
        payload: err,
    };
}
export function initCopMeetingAndTrainingReviewActionStatus() {
    return {
        type: INIT_COP_USER_ACCESS_ACTION_STATUS,
    };
}
export function resetCopMeetingAndTrainingReviewModal() {
    return {
        type: RESET_COP_USER_ACCESS_MODAL,
    };
}


export function loadRestrictedRuleList(params) {
    return function(dispatch) {
      httpClient
        .get(UrlConfig.LOAD_MEETING_AND_TRAINING_INFO_SUB_FORIN, params)
        .then(resp => dispatch(loadRestrictedRuleListSuccess(resp)))
        .catch(err => dispatch(loadRestrictedRuleListFailure(err)));
    };
  }
  function loadRestrictedRuleListSuccess(resp) {
    return {
      type: LOAD_RESTRICTED_SECURITIES_RULE_SUCCESS,
      payload: resp
    };
  }
  function loadRestrictedRuleListFailure(err) {
    return {
      type: LOAD_RESTRICTED_SECURITIES_RULE_FAILURE,
      payload: err
    };
  }

  export function openFinishTaskModal(task) {
    const {id,participant} = task;
    return openOperationRecordDialogAndQuery(id,participant);
    // return {
    //     type: OPEN_FINISH_TASK_MODAL,
    //     payload: task,
    // };
}


// query page
function openOperationRecordDialog(queryParams) {
    return {
        type: OPEN_OPERATION_RECORD_DIALOG,
        payload: queryParams,
    };
}
function startQueryOperationRecord() {
    return {
        type: START_QUERY_OPERATION_RECORD,
    }
}
function openOperationRecordDialogAndQuery(id,participant) {
   
    const queryParams = {
      
        id:id,
        participant:participant
    }

    return function(dispatch) {
        dispatch(openOperationRecordDialog(queryParams));
        dispatch(startQueryOperationRecord());
        httpClient
          .get(UrlConfig.LOAD_MEETING_AND_TRAINING_INFO_SUB_BY_MEETINGID, queryParams)
          .then(resp => dispatch(queryOperationRecordSuccess(resp)))
          .catch(err => dispatch(queryOperationRecordFailure(err)));
    };
}
function queryOperationRecordSuccess(resp) {
    return {
        type: QUERY_OPERATION_RECORD_SUCESS,
        payload: resp,
    }
}
function queryOperationRecordFailure(err) {
    return {
        type: QUERY_OPERATION_RECORD_FAILURE,
        payload: err,
    }
}
function initQueryOperationRecordStatus() {
    return {
        type: INIT_QUERY_OPERATION_RECORD_STATUS,
    }
}
function resetOperationRecordDialog() {
    return {
        type: RESET_OPERATION_RECORD_DIALOG,
    }
}


export function doOperationRecordAction(params) {
    const {action, queryFields, customColumns, detail} = params;
    if(action === 'OPEN_AND_QUERY') {
        return openOperationRecordDialogAndQuery(queryFields, customColumns);
    } else if(action === 'INIT_QUERY') {
        return initQueryOperationRecordStatus();
    } else if(action === 'RESET_QUERY') {
        return resetOperationRecordDialog();
    } else if(action === 'SHOW_DETAIL') {
        return showDetailRcd(detail);
    } else if(action === 'RESET_DETAIL') {
        return resetDetailRcd();
    }
}

// detail page
function showDetailRcd(detail) {
    return {
        type: SHOW_DETAIL_RCD,
        payload: detail,
    }
}
function resetDetailRcd() {
    return {
        type: RESET_DETAIL_RCD,
    }
}
  


export function loadInstituteUserAccounts(params) {
    return function(dispatch) {
      httpClient
        .get(UrlConfig.QUERY_INSTITUTE_USER_ACCOUNTS, params)
        .then(resp => dispatch(loadInstituteUserAccountsSuccess(resp)))
        .catch(err => dispatch(loadInstituteUserAccountsFailure(err)));
    };
}
function loadInstituteUserAccountsSuccess(resp) {
  return {
      type: LOAD_INSTITUTE_USER_ACCOUNT_SUCCESS,
      payload: resp,
  };
}
function loadInstituteUserAccountsFailure(err) {
  return {
      type: LOAD_INSTITUTE_USER_ACCOUNT_FAILURE,
      payload: err,
  };
}
